import { Mutations } from "vuex";
import { WalletState, WalletMutations } from "./types";

export const mutations: Mutations<WalletState, WalletMutations> = {
  updateWallet(state, payload) {
    Object.assign(state, payload);
  },
};
